// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const SubscriptionIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M1.83 10.43c-.18 0-.33.15-.33.33v4.88c0 3.08 1.98 5.16 4.93 5.16h11.14c2.95 0 4.93-2.08 4.93-5.16v-4.88c0-.18-.15-.33-.33-.33z"
        clipRule="evenodd"
        opacity=".5"
      />
      <path
        fillRule="evenodd"
        d="M22.17 8.77c.18 0 .33-.15.33-.33v-.08c0-3.08-1.98-5.16-4.93-5.16H6.43C3.48 3.2 1.5 5.28 1.5 8.36v.08c0 .18.15.33.33.33z"
        clipRule="evenodd"
      />
      <path d="M6.67 16.33h3.28c.46 0 .83-.37.83-.83s-.37-.82-.83-.82H6.67c-.46 0-.83.37-.83.82 0 .46.37.83.83.83" />
    </g>
  </SvgIcon>
);

export default SubscriptionIcon;
